import { AutoComplete, Checkbox, Col, Divider, Form, Input, InputNumber, Row, Select } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../../../context/AuthProvider';
import { updateField } from '../../../../../contextRedux/Offer/OfferModel';
import { RootState } from '../../../../../store';

const CompanyDetailsTab: React.FC = () => {
  const useQueryHook = () => new URLSearchParams(useLocation().search);
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const query = useQueryHook();

  const companyIdFromRoute = query.get('companyId');

  //initialize from offer
  const id = useSelector((state: RootState) => state?.models?.offer?.id);
  const companyId = useSelector((state: RootState) => state?.models?.offer?.companyId);
  const reduxOffer = useSelector((state: RootState) => state?.models?.offer);

  //initialize from parrent NewOffer
  const companies = useSelector((state: RootState) => state.store.company.data);
  const status = useSelector((state: RootState) => state?.store.statusOffer.data);
  const accountSales = useSelector((state: RootState) => state?.store.user.data);

  //initialize context
  const { profile } = useAuth();

  const currentDate = moment().format('YYYY-MM-DD');

  const initialValues = {
    company: useSelector((state: RootState) => state?.models?.offer?.company),
    companyId: useSelector((state: RootState) => state?.models?.offer?.companyId),
    accountManager: useSelector((state: RootState) => state?.models?.offer?.accountManager),
    accountSale: useSelector((state: RootState) => state?.models?.offer?.accountSale),
    accountSaleId: useSelector((state: RootState) => state?.models?.offer?.accountSaleId),
    enumOfferStatus: useSelector((state: RootState) => state?.models?.offer?.enumOfferStatus),
    enumOfferStatusId: useSelector((state: RootState) => state?.models?.offer?.enumOfferStatusId),
    date: useSelector((state: RootState) => state?.models?.offer?.date),
    dateStart: useSelector((state: RootState) => state?.models?.offer?.dateStart),
    dateEnd: useSelector((state: RootState) => state?.models?.offer?.dateEnd),
    datePeriod: useSelector((state: RootState) => state?.models?.offer?.datePeriod),
    acquisitionType: useSelector((state: RootState) => state?.models?.offer?.acquisitionType),
    intervention: useSelector((state: RootState) => state?.models?.offer?.intervention),
    hasUnlimitedInterventions: useSelector((state: RootState) => state?.models?.offer?.hasUnlimitedInterventions),
    isExpedite: useSelector((state: RootState) => state?.models?.offer?.isExpedite),
  };

  useEffect(() => {
    if (!!companyIdFromRoute && companies?.length > 0) {
      const selectedCompany = companies.find((c: any) => c?.id == companyIdFromRoute);
      const fieldsValue = {
        ...form.getFieldsValue(true),
        company: { name: selectedCompany?.name },
        companyId: selectedCompany?.id,
        accountManager: selectedCompany?.accountManager,
      };

      dispatch(updateField({ field: 'companyId', value: selectedCompany?.id ?? null }));
      dispatch(updateField({ field: 'company', value: selectedCompany ?? null }));

      dispatch(updateField({ field: 'accountManagerId', value: selectedCompany?.accountManager?.id ?? null }));
      dispatch(updateField({ field: 'accountManager', value: selectedCompany?.accountManager ?? null }));

      form.setFieldsValue(fieldsValue);
    }
  }, [companyIdFromRoute]);

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const handleSelectClient = (value: any) => {
    const company = companies.find((company: any) => company.name === value?.label);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      company: { name: company?.name },
      companyId: company?.id,
      accountManager: company?.accountManager,
    };

    form.setFieldsValue(fieldsValue);

    dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
    dispatch(updateField({ field: 'company', value: company ?? null }));

    dispatch(updateField({ field: 'accountManagerId', value: company?.accountManager?.id ?? null }));
    dispatch(updateField({ field: 'accountManager', value: company?.accountManager ?? null }));
  };

  const handleSelectAccountSales = (value: string) => {
    const accountSale = accountSales?.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      accountSale: accountSale,
      accountSaleId: accountSale?.id,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'accountSaleId', value: accountSale?.id ?? null }));
    dispatch(updateField({ field: 'accountSale', value: accountSale ?? null }));
  };

  const handleSelectStatus = (value: string) => {
    const selectStatus = status.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumOfferStatusId: selectStatus?.id,
      enumOfferStatus: selectStatus,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumOfferStatusId', value: selectStatus?.id ?? null }));
    dispatch(updateField({ field: 'enumOfferStatus', value: selectStatus ?? null }));
  };

  useEffect(() => {
    if (companyId) {
      const company = companies.find((company: any) => company.id === companyId);
      form.setFieldsValue({
        company: { name: company?.name },
        companyId: company?.id,
        accountManager: company?.accountManager,
      });
      dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
      dispatch(updateField({ field: 'company', value: company ?? null }));
      form.setFieldsValue({
        ...initialValues,
      });
      if (id == null || id == undefined || id == '') {
        handleSelectAccountSales(profile?.name!);
      }
    }
  }, [companyId]);

  useEffect(() => {
    if (id == null || id == undefined || id == '') {
      const currentDate = new Date().toISOString().split('T')[0];
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split('T')[0];

      form.setFieldsValue({
        ...initialValues,
      });

      dispatch(updateField({ field: 'enumOfferStatusId', value: 1 }));
      dispatch(updateField({ field: 'enumOfferStatus', value: { id: 1, name: 'Lead' } }));
      dispatch(updateField({ field: 'date', value: currentDate }));
      dispatch(updateField({ field: 'dateStart', value: currentDate }));
      dispatch(updateField({ field: 'dateEnd', value: formattedOneYearLater }));
      dispatch(updateField({ field: 'datePeriod', value: 30 }));
      dispatch(updateField({ field: 'acquisitionType', value: 'transfer bancar' }));
    }
  }, [id]);

  useEffect(() => {
    const uniqueSystemTypeIds = Array.from(
      new Set(reduxOffer.offerWorkPlaceItems.filter((c: any) => c.systemTypeId).map((c: any) => c.systemTypeId))
    );

    dispatch(updateField({ field: 'intervention', value: uniqueSystemTypeIds.length }));
    form.setFieldValue('intervention', uniqueSystemTypeIds.length);
  }, [reduxOffer.offerWorkPlaceItems]);

  const onDateChange = (dateField: string, dateValue: string) => {
    dispatch(updateField({ field: dateField, value: dateValue }));
    form.setFieldsValue({ [dateField]: dateValue });
  };

  const handleBlurClear = (fieldNames: string[]) => {
    fieldNames.forEach((field) => {
      form.setFieldsValue({ [field]: null });
      dispatch(updateField({ field, value: null }));
    });
  };

  const handleIsUrgentCheckbox = (value: boolean) => {
    if (value) {
      dispatch(updateField({ field: 'isExpedite', value: value }));
    }
  };

  const handleChangeUnlimitedInterventions = (value: boolean) => {
    dispatch(updateField({ field: 'hasUnlimitedInterventions', value: value }));
  };

  return (
    <Form form={form} onValuesChange={handleFieldChange} layout='vertical' style={{ margin: '20px 20px' }}>
      <Row gutter={[10, 10]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['company', 'name']}
            label='Selectati Client'
            rules={[{ required: true, message: 'Alegeti un client!' }]}
          >
            <Select
              disabled={!!id}
              showSearch // Enables search functionality
              placeholder='Search and select a client'
              optionFilterProp='label'
              onSelect={(_value, option: any) => {
                handleSelectClient(option);
              }}
              onChange={() => handleBlurClear(['company', 'companyId'])} // Clear form fields when changed
              filterOption={(input, option) => {
                return option?.label?.toLowerCase()?.includes(input.toLowerCase());
              }}
              options={companies?.map((company) => ({
                value: company?.id,
                label: company?.name,
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountManager', 'name']}
            label='Manager de cont'
            rules={[{ required: true, message: 'Alegeti un manager de cont!' }]}
          >
            <Input disabled={true} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountSale', 'name']}
            label='Agent Vanzari'
            rules={[{ required: true, message: 'Alegeti un agent de vanzari!' }]}
          >
            <AutoComplete
              options={accountSales?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectAccountSales}
              onChange={() => handleBlurClear(['accountSale', 'accountSaleId'])}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item name={['enumOfferStatus', 'name']} label='Status'>
            <AutoComplete
              options={status?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectStatus}
              onChange={() => handleBlurClear(['enumOfferStatus', 'enumOfferStatusId'])}
            />
          </Form.Item>
        </Col>
        <Divider />
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label='Data Oferta' name='date' rules={[{ required: true, message: 'Introduceti data oferta!' }]}>
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('date', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Inceput'
            name='dateStart'
            rules={[{ required: true, message: 'Introduceti data inceput!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateStart', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Sfarsit'
            name='dateEnd'
            rules={[{ required: true, message: 'Introduceti data sfarsit!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateEnd', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Perioada Ofertuala'
            name='datePeriod'
            rules={[{ required: true, message: 'Introduceti perioada ofertuala!' }]}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Achizitie'
            name='acquisitionType'
            rules={[
              {
                required: true,
                message: 'Introduceticeti tipul de achizitie!',
              },
            ]}
          >
            <Select>
              <Select.Option value='numerar'>Numerar</Select.Option>
              <Select.Option value='cash'>Cash</Select.Option>
              <Select.Option value='transfer bancar'>Transfer Bancar</Select.Option>
              <Select.Option value='bilet la ordin'>Bilet la Ordin</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        {!reduxOffer.hasUnlimitedInterventions && (
          <Col xs={24} sm={12} md={8}>
            {(!reduxOffer.id || !reduxOffer.hasUnlimitedInterventions) && (
              <Form.Item
                label='Intervenții Corective'
                name='intervention'
                initialValue={3}
                rules={[
                  {
                    required: true,
                    message: 'Introduceți numărul de intervenții corective!',
                  },
                ]}
              >
                <InputNumber disabled={!!reduxOffer.id} style={{ width: '100%' }} />
              </Form.Item>
            )}
          </Col>
        )}
        {(!reduxOffer.id || reduxOffer.hasUnlimitedInterventions) && (
          <Col xs={24} sm={12} md={8}>
            <Form.Item label='Intervenții Nelimitate' name='hasUnlimitedInterventions' valuePropName='checked'>
              <Checkbox
                disabled={!!reduxOffer.id}
                onChange={(e) => {
                  handleChangeUnlimitedInterventions(e.target.checked);
                  if (e.target.checked) {
                    form.setFieldsValue({ intervention: undefined });
                  }
                }}
              />
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={12} md={8}>
          <Form.Item label='Urgent' name='isExpedite' valuePropName='checked'>
            <Checkbox onChange={(e) => handleIsUrgentCheckbox(e.target.checked)} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CompanyDetailsTab;
